import React from "react";
import { AuthenticationMethod } from "src/Core/Common/Enums";

interface IAuthMethodCardProps {
    authMethod: AuthenticationMethod;
    cardTitle: string;
    cardImage: any;
    isActive: boolean;
    isDefault: boolean;
    disabled: boolean;
    allowToChangeDefaultMethod: boolean;
    onMethodClick: () => void;
    onSetDefaultClick: (e: any, authMethod: AuthenticationMethod) => void;
}

const AuthMethodCard: React.FC<IAuthMethodCardProps> = props => {
    return (
        <div
            className={`AuthMethodCard-wrapper flex-coloumn-centred
             ${props.isActive ? "active-card" : ""} ${props.disabled ? "disabled-card" : ""}`}
            onClick={!props.disabled && props.onMethodClick}
        >
            <p>{props.cardTitle}</p>
            <img className="auth_method_img" src={props.cardImage} alt="Question and answer method" />
            {!props.isDefault ? (
                props.allowToChangeDefaultMethod &&
                !props.disabled && (
                    <a
                        onClick={e => props.onSetDefaultClick(e, props.authMethod)}
                        className="link-primary mark-default-link"
                    >
                        Mark as default
                    </a>
                )
            ) : (
                <p className="link-primary mark-default-link always-show">Default</p>
            )}
        </div>
    );
};

export default AuthMethodCard;
